import { z } from 'zod';

export const supertypeSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  description: z.string(),
  categoryScoreMultiplier: z
    .number()
    .min(0, 'Category score multiplier must be greater than 0')
    .max(1, 'Category score multiplier must be less than 1'),
  categories: z.array(z.tuple([z.string(), z.number()])),
});

export type SupertypeFormData = z.infer<typeof supertypeSchema>;
